export default "__VITE_ASSET__BuRNHwKr__"